import { render, staticRenderFns } from "./login.vue?vue&type=template&id=8f8d9220&scoped=true&lang=pug&"
import script from "./login.vue?vue&type=script&lang=js&"
export * from "./login.vue?vue&type=script&lang=js&"
import style0 from "@ui-common/vue-captcha/dist/vue-captcha.css?vue&type=style&index=0&lang=css&"
import style1 from "./login.vue?vue&type=style&index=1&id=8f8d9220&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8d9220",
  null
  
)

export default component.exports